// extracted by mini-css-extract-plugin
export var cardSelected = "_er-2";
export var image = "_er-1";
export var table = "_er-0";